function isWholeNumber(value: number): boolean{
    return value - Math.floor(value) === 0;
}

function formatInteger(value: string, separator: string ): string{
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

function numberToLocalFormat(value: number, locale: string = 'en-GB', fractionDigits: number = 2): string
{
    let decimalSeparator = '.';
    let integerSeparator  = ',';
    // all int countries we currently support use this format
    if (locale !== 'en-GB'){
        decimalSeparator = ',';
        integerSeparator = '.';
    }

    if (isWholeNumber(value)){
        return formatInteger(value.toString(), integerSeparator);
    }

    const numString = value.toFixed(fractionDigits);
    const parts = numString.split('.');
    const integer = formatInteger(parts[0], integerSeparator); // comma separated interger
    const fraction = parts[1] || '';
    if (fractionDigits === 0){
        return integer;
    }

    return integer + decimalSeparator + fraction;
}

export { numberToLocalFormat };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/utils/number-formatter.ts